export default __webpack_public_path__ + "static/icomoon-206d83f1bdba373945ea47f08ead427c.ttf";